import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

/**
 * The signed-out page frame: Icewall blob, brand panel, and a card on the
 * right. Shared by sign-in, password recovery and password reset so the three
 * do not drift apart visually.
 */
export default function AuthShell({
  heading,
  subheading,
  tagline,
  children,
}: {
  heading: string
  subheading: string
  tagline: ReactNode
  children: ReactNode
}) {
  return (
    <div className="relative min-h-screen overflow-hidden bg-primary bg-noise xl:bg-background xl:bg-none">
      {/* Icewall signature: tilted rounded primary blob on the left (desktop) */}
      <div className="absolute -left-[26%] -top-[30%] hidden h-[160%] w-[76%] rotate-[6deg] rounded-[35%] border-[20px] border-primary/20 bg-primary/95 bg-noise xl:block" />

      <div className="relative z-10 mx-auto flex min-h-screen max-w-6xl items-center px-5">
        {/* Left: brand + illustration + hero */}
        <div className="hidden w-1/2 flex-col pr-16 xl:flex">
          <div className="flex items-center">
            <Link to="/" title="MPG marketplace">
              <img src="/logo_hd_white.png" alt="MPG Printing" className="h-8 w-auto object-contain" />
            </Link>
          </div>
          <img src="/auth-illustration.webp" alt="" className="mt-14 w-3/4" />
          <h1 className="mt-10 text-4xl font-medium leading-tight text-white">{tagline}</h1>
          <p className="mt-4 text-lg text-white opacity-60">
            Manage your apparel orders, wallet and production in one place
          </p>
        </div>

        <div className="flex w-full justify-center xl:w-1/2 xl:justify-end">
          <div className="box w-full max-w-md p-8 xl:border-0 xl:bg-transparent xl:shadow-none xl:before:hidden">
            <h2 className="text-center text-2xl font-semibold text-foreground xl:text-left xl:text-3xl">{heading}</h2>
            <p className="mt-2 text-center text-sm text-foreground/60 xl:text-left">{subheading}</p>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
